const map = {
  opened: 'Aberto',
  paid: 'Pago',
  paying: 'Pagando',
  error: 'Erro',
  closed: 'Fechado',
}

export default str => map[str] || str
